import Link from "next/link";

import { Project } from "interfaces";

import { useFetchDataFile } from "modules/data-files/api";

import {
  TimeSeriesProject,
  projectIsTimeSeriesAnalysis,
} from "flows/time-series/interfaces";

import { getDataFileId } from "flows/time-series/utils";

const DataFileSummary = ({ project }: { project: Project }) => {
  const inputData = getDataFileId(project as TimeSeriesProject);
  const { data: fileDetails } = useFetchDataFile(inputData, true);

  if (!projectIsTimeSeriesAnalysis(project)) {
    return null;
  }

  return (
    <div className="m-1">
      <p className="mb-2">
        <span className="font-semibold">Input Data:</span>{" "}
        <Link href={`/data-files/${inputData}`}>
          <a className="text-primary-main">{fileDetails?.name || inputData}</a>
        </Link>
      </p>
    </div>
  );
};

export default DataFileSummary;
